function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M445.217,489.739H66.783c-24.588,0-44.522-19.934-44.522-44.522V66.783 c0-24.588,19.933-44.522,44.522-44.522h378.435c24.588,0,44.522,19.933,44.522,44.522v378.435 C489.739,469.806,469.806,489.739,445.217,489.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAF781"
    },
    d: "M489.739,143.026v302.191c0,24.588-19.934,44.522-44.522,44.522H66.783 c-24.588,0-44.522-19.934-44.522-44.522V371.2h0.001c0.267,0,0.534-0.096,0.748-0.289l122.116-111.015h144.265 c0.286,0,0.561-0.11,0.768-0.308l122.113-116.561H489.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92B703"
    },
    d: "M509.555,147.815l-22.261,22.261c-1.631,1.63-3.768,2.445-5.904,2.445s-4.273-0.815-5.904-2.445 c-3.26-3.26-3.26-8.546,0-11.805l8.011-8.011H415.17l-120.014,114.56c-1.554,1.483-3.617,2.31-5.764,2.31H147.922L27.876,376.264 c-1.599,1.454-3.61,2.17-5.612,2.17c-2.271,0-4.532-0.92-6.18-2.733c-3.101-3.411-2.849-8.691,0.562-11.793l122.435-111.304 c1.536-1.397,3.538-2.17,5.615-2.17h141.351l120.015-114.56c1.554-1.483,3.617-2.31,5.764-2.31h71.672l-8.011-8.011 c-3.26-3.26-3.26-8.546,0-11.805c3.261-3.26,8.546-3.26,11.806,0l22.261,22.261C512.815,139.269,512.815,144.556,509.555,147.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#768900"
    },
    d: "M311.652,258.783c0,12.295-9.966,22.261-22.261,22.261c-12.295,0-22.261-9.966-22.261-22.261 c0-12.295,9.966-22.261,22.261-22.261C301.686,236.522,311.652,246.488,311.652,258.783z M141.913,236.522 c-12.295,0-22.261,9.966-22.261,22.261c0,12.295,9.966,22.261,22.261,22.261s22.261-9.966,22.261-22.261 C164.174,246.488,154.208,236.522,141.913,236.522z M22.261,347.826C9.966,347.826,0,357.792,0,370.087 c0,12.295,9.966,22.261,22.261,22.261s22.261-9.966,22.261-22.261C44.522,357.792,34.556,347.826,22.261,347.826z M406.261,119.652 c-12.295,0-22.261,9.966-22.261,22.261c0,12.295,9.966,22.261,22.261,22.261c12.295,0,22.261-9.966,22.261-22.261 S418.556,119.652,406.261,119.652z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigGraph);
export default __webpack_public_path__ + "static/media/config_graph.6493b98115cb1b14f9cfe96c93e25f69.svg";
export { ForwardRef as ReactComponent };